import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLandplotsLayers, setLandplotsLayers } from "../../slices/app";
export const useLandplotsLayers = () => {
    const dispatch = useDispatch();
    const value = useSelector(getLandplotsLayers);
    const update = useCallback((updatedValue) => {
        dispatch(setLandplotsLayers(updatedValue));
    }, [dispatch]);
    return [value, update];
};
